<script setup lang="ts">
import { DropdownMenuRoot } from "reka-ui";

const props = defineProps({});
</script>

<template>
  <DropdownMenuRoot v-bind="props">
    <slot />
  </DropdownMenuRoot>
</template>
